export default class TransferError extends Error {
  constructor(message, args = {}) {
    super(message);
    this.transferId = args.transferId;
  }
}
